<template>
    <section class="categories page__section brands_screen vidget_wrap vidget_wrap">
        <h2 class="page__h1 cats_title detectMobVisibility" v-html="$t('brands.title')"></h2>
        <div class="categories__list detectMobVisibility">
            <swiper :options="swiperOption" ref="mySwiper" class="swiperBox blackBack categoriesSwipe">
                <swiper-slide>
                    <div class="categories__item" data-category="1">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-gadgets"></span>
                        <span class="categories__name">{{ $t('brands.gadgets') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="2">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-smart_home"></span>
                        <span class="categories__name">{{ $t('brands.smart_home') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="3">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-vape"></span>
                        <span class="categories__name">{{ $t('brands.vape') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="4">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-audio_video"></span>
                        <span class="categories__name">{{ $t('brands.av') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="5">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-electric"></span>
                        <span class="categories__name">{{ $t('brands.electric') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="6">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-accessories"></span>
                        <span class="categories__name">{{ $t('brands.accessories') }}</span>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="categories__item" data-category="7">
                        <div class="hover_action"><span></span><span></span><span></span><span></span></div>
                        <span class="categories__icon icon-household"></span>
                        <span class="categories__name">{{ $t('brands.household') }}</span>
                    </div>
                </swiper-slide>
            </Swiper>
            <div class="swiper_navigation">
                <div class="swiper-button-prev icon-left_arrow" id="cats_prev"></div>
                <div class="swiper-button-next icon-right_arrow" id="cats_next"></div>
            </div>
        </div>
        <div class="brands exclusive_brands detectMobVisibility">
            <span class="br_list_title exc_brands_title"><span class="textHide"><span>{{ $t('brands.exclusive') }}</span></span></span>
            <div class="br_list_wrap exc_brands_list">
                <div class="br_list_container">
                    <div class="br_lisr_cont_wrap textFade">
                        <div class="brnd_item div_item" v-for="(item, index) in brandsArr" :key="item">
                            <div class="brand_holder">
                                <i :class="item"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="brands__link" @click="showBrands">{{ $t('buttons.explore_brands') }} →</div>
        </div>
    </section>
</template>

<script>
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    
    export default {
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
				activeCat: 1,
                brandsArr: ['icon-b_yunmai', 'icon-b_elari', 'icon-b_ecovacs', 'icon-b_cecotec', 'icon-b_fixitime', 'icon-b_ticwatch', 'icon-b_jimmy', 'icon-b_dreame', 'icon-b_deerma'],
                swiperOption: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true,
                    navigation: {
                        nextEl: '#cats_next',
                        prevEl: '#cats_prev'
                    },
                    breakpoints: {
                        1850: {
                            slidesPerView: 5
                        },
                        1600: {
                            slidesPerView: 4
                        },
                        1350: {
                            slidesPerView: 3
                        },
                        1120: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 'auto'
                        }
                    }
                },
                onSlideChangeEnd: function() {
                    this.onSwipe()
                }
            }
        },
        methods: {
            showBrands() {
                if($(window).width() >= 1024) {
                    setTimeout(function() {$('.fp-section[data-anchor="brands"]').addClass('brands_open');}, 500);
                    $.fn.fullpage.moveTo('brands', 1);
                }
                else {
                    $('body').addClass('brandsListOpen');
                    setTimeout(function() {$('body').addClass('brandsIn');}, 500);
                }
            },
			onSwipe(obj) {
		//		console.log(obj.swiper.activeIndex);
			}
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
		mounted() {
			this.swiper.on('slideChange',()=>{
                this.onSwipe(this)
            });
			
			var gbl = this,
                glTime = 0;
			
			$('.categories__item').on('mouseenter', function() {
                clearTimeout(glTime);
                var thiSlide = $(this).parent();
                
                glTime = setTimeout(function() {
                    if(!thiSlide.hasClass('this_hovered')) {
                        thiSlide.addClass('this_hovered');
                    }
                }, 200);
			}).on('mouseleave', function() {
                clearTimeout(glTime);
                $(this).parent().removeClass('this_hovered');
			});
            
		}
    }
</script>

<style lang="stylus" scoped>
    .swiper_navigation
        position absolute
        top -10px
        left -255px
        
        @media (min-width 1600px)
            left -240px
    
    #cats_prev
        width 40px
        height 40px
        top 0
        right auto
        left 0
        background none
        margin 0
        font-size 14px
        color #808080
        text-align center
        line-height 40px
        
        &:hover
            color #000
        
    #cats_next
        width 40px
        height 40px
        top 0
        right auto
        left 40px
        background none
        margin 0
        font-size 14px
        color #808080
        text-align center
        line-height 40px
        
        &:hover
            color #000
        
    
    .swiper-slide
        width 224px
    
    .brands_screen
        position relative
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
    
    .categories
        background #fff
        color #000
        overflow hidden

    .exc_brands_title, .exc_brands_list
        margin-left 0
        
    .exc_brands_list
        height auto
        overflow hidden
        
        @media (max-width 1023px)
            margin-bottom 20px

    .br_lisr_cont_wrap
        display flex
        flex-flow wrap

    .categories__list
        width calc(100% + 20px)
        margin 48px 0
        position relative
        
        @media (min-width 700px)
            width 100%

    .categories__item
        width 224px
        height 344px
        position relative
        min-width 224px

        &:not(:last-child)
            margin-right 20px
            
        @media (min-width 1024px)
            width 100%
            min-width 0
            top 101px
            cursor pointer

    @media (min-width 1024px)
        .exclusive_brands
            padding-bottom 80px
                    
    .categories__name
        color #fff
        position absolute
        left 24px
        bottom 32px
        font-size 18px
        line-height 1
        font-weight 600
        z-index 2

    .categories__icon
        color #fff
        font-size 72px
        position absolute
        top 48px
        right 40px
        z-index 3
        height calc(100% - 48px)

    .brands__list
        margin 32px -32px
        display flex
        flex-wrap wrap

        @media (min-width 1024px)
            width 665px

    .brands__item
        width 50%
        height 135px
        border-bottom 1px solid #f7f7f7
        display flex
        justify-content center
        align-items center
        color #D5D7DB
        font-size 32px
        position relative

        @media (min-width 1024px)
            width 33.33%
            border none

    .brands__link
        color #999
        font-size 14px
        display inline-block
        cursor pointer
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)

        &:hover
            color #000

    .cats_title
        padding-top 75px
        position relative
        z-index 2
        
        @media (min-width 1024px)
            padding-top 130px
	
	.swiperBox {
		z-index 2
	}
	
	
    .hover_action {
        width 100%
        height 100%
        position absolute
        z-index 1
        top 0
        left 0
        overflow hidden
        background #222
        -webkit-transition all .3s ease
        -moz-transition all .3s ease
        transition all .3s ease
        
        span {
            display block
            position absolute
            opacity 0
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)
            
            &:nth-child(1) {
                -webkit-transform rotate(-4deg)
                -moz-transform rotate(-4deg)
                transform rotate(-4deg)
                margin -20px 0 0 -10px
            }
            
            &:nth-child(2) {
                -webkit-transform rotate(4deg)
                -moz-transform rotate(4deg)
                transform rotate(4deg)
                margin -10px -35px 0 0
            }
            
            &:nth-child(3) {
                -webkit-transform rotate(-6deg)
                -moz-transform rotate(-6deg)
                transform rotate(-6deg)
                margin -10px 0 0 -40px
            }
            
            &:nth-child(4) {
                -webkit-transform rotate(8deg)
                -moz-transform rotate(8deg)
                transform rotate(8deg)
                margin 0 -30px -25px 0
            }
            
            &:nth-child(5) {
                -webkit-transform rotate(-7deg)
                -moz-transform rotate(-7deg)
                transform rotate(-7deg)
                margin 0 0 -35px -35px
            }
            
            &:after {
                width 100%
                height 100%
                display block
                position relative
                content ''
                background-size contain
                background-position center
                background-repeat no-repeat
            }
        }
        
        
    }
    
    .hover_item.ease_out {
        .hover_action {
            -webkit-transition all .2s ease
            -moz-transition all .2s ease
            transition all .2s ease
        }
    }
	
    .startAnim {
        @media (min-width 1024px) {
            .hover_item.active .hover_action {
                width calc(100% + 136px)
                height 100%
                opacity 1
                top 0
                left 0
                margin-left -68px
                background #2858A2
                
                span {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                    margin 0
                }
            }
        }
    }
	
	.categories__item[data-category="1"] .hover_action {
		span {
            width 98px
            height 120px
            
            &:after {
                background-image url('../assets/images/hov_a.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 292px)
                left calc(50% - 106px)
                
                &:after {
                    -webkit-transform rotate(-30deg)
                    -moz-transform rotate(-30deg)
                    transform rotate(-30deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 90px)
                right calc(50% - 182px)
                
                &:after {
                    -webkit-transform rotate(30deg)
                    -moz-transform rotate(30deg)
                    transform rotate(30deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 10px)
                left calc(50% - 150px)
                
                &:after {
                    -webkit-transform rotate(6deg)
                    -moz-transform rotate(6deg)
                    transform rotate(6deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 254px)
                right calc(50% - 132px)
                
                &:after {
                    -webkit-transform rotate(-8deg)
                    -moz-transform rotate(-8deg)
                    transform rotate(-8deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 340px)
            //     left calc(50% - 215px)
                
            //     &:after {
            //         -webkit-transform rotate(-53deg)
            //         -moz-transform rotate(-53deg)
            //         transform rotate(-53deg)
            //     }
            // }
        }
	}
	.categories__item[data-category="2"] .hover_action {
		span {
            width 136px
            height 136px
            
            &:after {
                background-image url('../assets/images/hov_b.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 310px)
                left calc(50% - 94px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 136px)
                right calc(50% - 190px)
                
                &:after {
                    -webkit-transform rotate(22deg)
                    -moz-transform rotate(22deg)
                    transform rotate(22deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 38px)
                left calc(50% - 170px)
                
                &:after {
                    -webkit-transform rotate(-28deg)
                    -moz-transform rotate(-28deg)
                    transform rotate(-28deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 258px)
                right calc(50% - 160px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 350px)
            //     left calc(50% - 225px)
                
            //     &:after {
            //         -webkit-transform rotate(-35deg)
            //         -moz-transform rotate(-35deg)
            //         transform rotate(-35deg)
            //     }
            // }
        }
	}
	.categories__item[data-category="3"] .hover_action {
		span {
            width 59px
            height 123px
            
            &:after {
                background-image url('../assets/images/hov_c.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 282px)
                left calc(50% - 120px)
                
                &:after {
                    -webkit-transform rotate(-12deg)
                    -moz-transform rotate(-12deg)
                    transform rotate(-12deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 144px)
                right calc(50% - 138px)
                
                &:after {
                    -webkit-transform rotate(22deg)
                    -moz-transform rotate(22deg)
                    transform rotate(22deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 0px)
                left calc(50% - 180px)
                
                &:after {
                    -webkit-transform rotate(8deg)
                    -moz-transform rotate(8deg)
                    transform rotate(8deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 280px)
                right calc(50% - 140px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 350px)
            //     left calc(50% - 180px)
                
            //     &:after {
            //         -webkit-transform rotate(40deg)
            //         -moz-transform rotate(40deg)
            //         transform rotate(40deg)
            //     }
            // }
        }
	}
	.categories__item[data-category="4"] .hover_action {
		span {
            width 91px
            height 76px
            
            &:after {
                background-image url('../assets/images/hov_d.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 284px)
                left calc(50% - 90px)
                
                &:after {
                    -webkit-transform rotate(-15deg)
                    -moz-transform rotate(-15deg)
                    transform rotate(-15deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 122px)
                right calc(50% - 178px)
                
                &:after {
                    -webkit-transform rotate(12deg)
                    -moz-transform rotate(12deg)
                    transform rotate(12deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - -10px)
                left calc(50% - 170px)
                
                &:after {
                    -webkit-transform rotate(-6deg)
                    -moz-transform rotate(-6deg)
                    transform rotate(-6deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 272px)
                right calc(50% - 210px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 310px)
            //     left calc(50% - 210px)
                
            //     &:after {
            //         -webkit-transform rotate(26deg)
            //         -moz-transform rotate(26deg)
            //         transform rotate(26deg)
            //     }
            // }
        }
	}
	.categories__item[data-category="5"] .hover_action {
		span {
            width 133px
            height 75px
            
            &:after {
                background-image url('../assets/images/hov_e.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 280px)
                left calc(50% - 122px)
                
                &:after {
                    -webkit-transform rotate(10deg)
                    -moz-transform rotate(10deg)
                    transform rotate(10deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 122px)
                right calc(50% - 190px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 10px)
                left calc(50% - 176px)
                
                &:after {
                    -webkit-transform rotate(-16deg)
                    -moz-transform rotate(-16deg)
                    transform rotate(-16deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 270px)
                right calc(50% - 160px)
                
                &:after {
                    -webkit-transform rotate(8deg)
                    -moz-transform rotate(8deg)
                    transform rotate(8deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 350px)
            //     left calc(50% - 170px)
                
            //     &:after {
            //         -webkit-transform rotate(84deg)
            //         -moz-transform rotate(84deg)
            //         transform rotate(84deg)
            //     }
            // }
        }
	}
    .icon-electric:before {
        width: 54px;
        height: 72px;
        display: block;
        background: url('~@/assets/images/svg/electric.svg') center no-repeat;
        content: '';
    }
	.categories__item[data-category="6"] .hover_action {
		span {
            width 60px
            height 150px
            
            &:after {
                background-image url('../assets/images/hov_f.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 360px)
                left calc(50% - 60px)
                
                &:after {
                    -webkit-transform rotate(30deg)
                    -moz-transform rotate(30deg)
                    transform rotate(30deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 168px)
                right calc(50% - 190px)
                
                &:after {
                    -webkit-transform rotate(-36deg)
                    -moz-transform rotate(-36deg)
                    transform rotate(-36deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 100px)
                left calc(50% - 158px)
                
                &:after {
                    -webkit-transform rotate(14deg)
                    -moz-transform rotate(14deg)
                    transform rotate(14deg)
                }
            }
            
            &:nth-child(4) {
                bottom calc(50% - 260px)
                right calc(50% - 172px)
                
                &:after {
                    -webkit-transform rotate(0deg)
                    -moz-transform rotate(0deg)
                    transform rotate(0deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 415px)
            //     left calc(50% - 160px)
                
            //     &:after {
            //         -webkit-transform rotate(-38deg)
            //         -moz-transform rotate(-38deg)
            //         transform rotate(-38deg)
            //     }
            // }
        }
	}
	.categories__item[data-category="7"] .hover_action {
		span {
            width 117px
            height 117px
            
            &:after {
                background-image url('../assets/images/hov_g.png')
            }
            
            &:nth-child(1) {
                top calc(50% - 288px)
                left calc(50% - 120px)
                
                &:after {
                    -webkit-transform rotate(-30deg)
                    -moz-transform rotate(-30deg)
                    transform rotate(-30deg)
                }
            }
            
            &:nth-child(2) {
                top calc(50% - 196px)
                right calc(50% - 228px)
                
                &:after {
                    -webkit-transform rotate(12deg)
                    -moz-transform rotate(12deg)
                    transform rotate(12deg)
                }
            }
            
            &:nth-child(3) {
                top calc(50% - 40px)
                left calc(50% - 188px)
            }
            
            &:nth-child(4) {
                bottom calc(50% - 276px)
                right calc(50% - 180px)
                
                &:after {
                    -webkit-transform rotate(-28deg)
                    -moz-transform rotate(-28deg)
                    transform rotate(-28deg)
                }
            }
            
            // &:nth-child(5) {
            //     bottom calc(50% - 415px)
            //     left calc(50% - 160px)
                
            //     &:after {
            //         -webkit-transform rotate(-38deg)
            //         -moz-transform rotate(-38deg)
            //         transform rotate(-38deg)
            //     }
            // }
        }
	}
    .icon-household:before {
        width: 55px;
        height: 56px;
        display: block;
        background: url('~@/assets/images/svg/household.svg') center no-repeat;
        content: '';
    }
    
    @media (min-width 1024px)
        .categoriesSwipe
            height 546px
            margin -101px auto
            overflow visible
            
            .swiper-slide
                z-index 5
            
                &.this_hovered
                    z-index 1
                
                    .hover_action
                        width calc(100% + 136px)
                        height calc(100% + 202px)
                        top -101px
                        left -68px
                        background-color #2858A2
                        
                        span
                            -webkit-transform rotate(0deg)
                            -moz-transform rotate(0deg)
                            transform rotate(0deg)
                            margin 0
                            opacity 1
	
                &.swiper-slide-visible + .swiper-slide:not(.swiper-slide-visible)
                    margin-left 150px !important
                
        .fp-section.startAnim
            .categoriesSwipe
                .swiper-slide
                    -webkit-transition .2s ease
                    -moz-transition .2s ease
                    transition .2s ease

    @media (max-width 1023px)
        .div_item
            position relative
            overflow visible
            
            .brand_holder
                width 100%
                height 80px
                position relative
                overflow hidden
            
            &:nth-of-type(1):before, &:nth-of-type(3):before, &:nth-of-type(5):before
                width 100vw
                height 1px
                display block
                content ''
                position absolute
                top 100%
                left 0vw
                background #F7F7F7

    .brand_holder
        height 100%

    .brand_holder i
        width 100%
        height 100%
        display block

    .icon-b_ecovacs
        margin-top -7px
        background url("~@/assets/images/svg/ecovacs.svg") center no-repeat

    .icon-b_cecotec
        margin-top -7px
        background url("~@/assets/images/cecotec.png") center no-repeat

    .icon-b_ticwatch
        margin-top -7px
        background url("~@/assets/images/svg/ticwatch.svg") center no-repeat

    .icon-b_jimmy
        margin-top -7px
        background url("~@/assets/images/svg/jimmy.svg") center no-repeat

    .icon-b_dreame
        margin-top -7px
        background url("~@/assets/images/svg/dreame.svg") center no-repeat

    .icon-b_deerma
        margin-top -7px
        background url("~@/assets/images/svg/deerma.svg") center no-repeat
	
</style>